<template>
  <div>
    <Table
      resource="QuestionCategory"
      :actions="actions"
      :items="$store.getters['questionCategory/tableData']"
      :detail="$store.getters['questionCategory/detailData']"
      :fields="$store.getters['questionCategory/tableFields']"
      :pagination="$store.state.questionCategory.tablePagination"
      :keyword="$store.state.questionCategory.tableKeyword"
      :loading="$store.state.questionCategory.loadingTable"
      :filter="$store.state.questionCategory.tableFilter"
      :sort="$store.state.questionCategory.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('questionCategory/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('questionCategory/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('questionCategory/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('questionCategory/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('questionCategory/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('questionCategory/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('questionCategory/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('questionCategory/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('questionCategory/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('questionCategory/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
